import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useRef } from "react";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LoadingPanel } from "../../components/layout/Loading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

import { closed } from "../../components/drawer/drawerSlice";
import { EDIT_TYPE, INSERT_TYPE, STATUSARRAY } from "../../_contstants/common";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import {
  createLeadSource,
  getAllLeadSource,
  getLeadSourceById,
  updateLeadSource,
} from "./services/leadsource.services";
import { clearLeadsourceDetails } from "./leadsourceSlice";

const CreateLeadSource: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const LeadSorceDetail = useAppSelector(
    (state) => state.leadsource.LeadSorceDetail
  );
  const LeadSourceGUID = useAppSelector((state) => state.drawer.data);
  const formLoading = useAppSelector((state) => state.leadsource.formLoading);

  useEffect(() => {
    return () => {
      dispatch(clearLeadsourceDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (LeadSourceGUID) {
      dispatch(getLeadSourceById(LeadSourceGUID));
    }
  }, [LeadSourceGUID]);

  const handleSubmit = async (values: any) => {
    try {
      if (!LeadSourceGUID) {
        const insertPayload = {
          LeadSource: values.LeadSource,
          IsActive: values.IsActive === 1,
          OperationType: INSERT_TYPE,
        };
        const response = await dispatch(createLeadSource(insertPayload));
        if (response?.payload?.Status === 201) {
          dispatch(closed());
          dispatch(clearLeadsourceDetails());
          dispatch(getAllLeadSource());
        }
      } else {
        const editPayload = {
          // ID:values.ID,
          LeadSourceGUID: LeadSourceGUID,
          LeadSource: values.LeadSource,
          IsActive: values.IsActive === 1,
          OperationType: EDIT_TYPE,
        };
        const response = await dispatch(updateLeadSource(editPayload));
        if (response?.payload?.Status === 200) {
          dispatch(closed());
          dispatch(clearLeadsourceDetails());
          dispatch(getAllLeadSource());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={LeadSorceDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem className="drawer-header">
              <Typography.h4 className="m-0">
                {LeadSourceGUID ? "Update Lead Source" : "Create Lead Source"}
              </Typography.h4>
              <Button
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => dispatch(closed())}
              >
                <RxCross1 />
              </Button>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="LeadSource"
                label="Lead Source"
                placeholder="Lead Source"
                component={FormTextField}
                validator={requiredValidator} astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"IsActive"}
                name={"IsActive"}
                label={"Status"}
                placeholder="Status"
                validator={requiredValidator} astrike={true}
                component={FormSelectionField}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                marginTop: 20,
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={LeadSourceGUID ? "Update" : "Create"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateLeadSource;
